const main = () => {
    document.querySelectorAll('.c-buttons-share').forEach((wrap) => {
        const trigger = wrap.querySelector('.c-buttons-share__button');
        const balloon = wrap.querySelector('.c-buttons-share__balloon');
        const closeBtn = wrap.querySelector('.c-buttons-share__balloon-close');
        const copyBtn = wrap.querySelector('.c-buttons-share__balloon-item--copy');

        if (!trigger || !balloon) return;
        if (wrap.dataset.shareBound) return;
        wrap.dataset.shareBound = '1';

        const open = () => {
            balloon.setAttribute('data-open', '');
            trigger.setAttribute('aria-expanded', 'true');
            balloon.removeAttribute('aria-hidden');
        };

        const close = () => {
            balloon.removeAttribute('data-open');
            trigger.setAttribute('aria-expanded', 'false');
            balloon.setAttribute('aria-hidden', 'true');
        };

        trigger.addEventListener('click', (e) => {
            e.stopPropagation();
            balloon.hasAttribute('data-open') ? close() : open();
        });

        if (closeBtn) {
            closeBtn.addEventListener('click', (e) => {
                e.stopPropagation();
                close();
            });
        }

        // 吹き出し外クリックで閉じる
        document.addEventListener('click', (e) => {
            if (!wrap.contains(e.target)) {
                close();
            }
        });

        // リンクコピー
        if (copyBtn) {
            const tip = copyBtn.querySelector('.c-buttons-share__copied-tip');
            copyBtn.addEventListener('click', async () => {
                const url = copyBtn.dataset.url;
                if (!url) return;
                try {
                    await navigator.clipboard.writeText(url);
                } catch {
                    // フォールバック
                    const ta = document.createElement('textarea');
                    ta.value = url;
                    ta.style.position = 'fixed';
                    ta.style.opacity = '0';
                    document.body.appendChild(ta);
                    ta.focus();
                    ta.select();
                    document.execCommand('copy');
                    document.body.removeChild(ta);
                }
                if (tip) {
                    tip.setAttribute('data-show', '');
                    setTimeout(() => {
                        tip.removeAttribute('data-show');
                    }, 1800);
                }
            });
        }
    });
};

export default main;
